import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { AdminViewTabs } from "constants/AdminViewConstants";
import UserAdminContent from "components/UserAdminContent/UserAdminContent";
import CannedMessageContent from "components/UserAdminContent/CannedMessageContent";
import "./UserAdminRightSection.scss";
import UserAdminBrochures from "components/UserAdminBrochures/UserAdminBrochures";

function UserAdminRightSection(props) {
  const { adminView } = props;
  const selectedSection = adminView.section;

  const renderBasedOnSelectedSection = () => {
    switch (selectedSection) {
      case AdminViewTabs.USER_SUMMARY:
        return <UserAdminContent />;
      case AdminViewTabs.BROCHURES:
        return <UserAdminBrochures />;
      case AdminViewTabs.CANNED_MESSAGES:
        return <CannedMessageContent />;
      default:
        return "";
    }
  };
  return (
    <div className="user-admin-right-section">
      {renderBasedOnSelectedSection()}
    </div>
  );
}

UserAdminRightSection.propTypes = {
  adminView: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  adminView: state.adminView,
});

export default connect(mapStateToProps)(UserAdminRightSection);
